<template>
  <anchor-modal
    header-color="primary"
    :max-width="maxWidth"
    :title="title"
    :loading="loading"
    :value="value"
    @input="val => $emit('input', val)"
  >
    <anchor-base-form
      ref="form"
      dense-btns
      prefix="approve-reject"
      class="mb-4"
      :loading="loading"
      v-model="valid"
      @cancel="handleCancel"
      @submit="handleSubmit"
    >
      <anchor-select
        class="mt-1"
        label="Decision"
        id="approve-reject-status-input"
        v-model="model.status"
        :items="options"
        :rules="rules.status"
      />
      <anchor-text-area
        id="approve-reject-notes-input"
        label="Notes"
        v-model="model.note"
        :rules="rules.note"
        :disabled="loading"
      />
    </anchor-base-form>
  </anchor-modal>
</template>

<script>
import AnchorModal from '../Modal';
import AnchorBaseForm from '../form/BaseForm';
import AnchorSelect from '../form/AnchorSelect';
import AnchorTextArea from '../form/AnchorTextarea';

export default {
  name: 'AnchorApproveRejectModal',
  components: {
    AnchorSelect,
    AnchorModal,
    AnchorBaseForm,
    AnchorTextArea,
  },
  props: {
    maxWidth: {
      type: [String, Number],
      default: 800,
    },
    options: {
      type: Array,
      required: true,
    },
    rules: {
      type: Object,
      required: false,
      default: () => ({ status: [], note: [] }),
    },
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Approve/Reject File',
    },
    loading: Boolean,
  },
  data() {
    return {
      valid: false,
      model: {
        status: undefined,
        note: undefined,
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', this.model);
    },
    handleCancel() {
      this.$emit('input', false);
      this.model.note = undefined;
      this.model.status = undefined;
    },
  },
};
</script>
